import React from 'react';
import ReadInventory from './Read';
import Stock from './StockList';
import WriteInventory from './Write';

export default function Inventory(props) {
  const { isUpdate, inputChange, dataProduct } = props; //data Products

  return isUpdate ? (
    <WriteInventory inputChange={inputChange} dataProduct={dataProduct} />
  ) : (
    <>
      <ReadInventory dataProduct={dataProduct} />
      <Stock dataProduct={dataProduct} />
    </>
  );
}
